import "./utility.scss"

export default function Utility() {
    return (
        <div className="utility">
            <div className="utilityTitle">
                <h1>NFT WITH UTILITY</h1>
            </div>
            <div className="utilityContent">
                <div className="utilityLeft">
                    <div className="leftContent">
                        <p>
                        Asides the obvious benefits to possessing an NFT with historical allusion, the NOK HEADS are more than they appear! Holding even one 3D NOK HEAD will enable you receive retroactive drops from our gaming platforms. Think of them like your pokemon. The more NOK you have, the higher your chances of wining a skirmish and taking home GOLD!
Who knows? You could even get one of the 6 great NOK Kings!
                        </p>
                    </div>

                </div>
                <div className="utilityRight">
                    <div className="rightContent">
                        <img src="assets/UtilityNok.png" alt="" />
                    </div>
                </div>
            </div>
        </div>
    )
}
